/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeasonPassStatus } from './SeasonPassStatus';
import {
    SeasonPassStatusFromJSON,
    SeasonPassStatusFromJSONTyped,
    SeasonPassStatusToJSON,
    SeasonPassStatusToJSONTyped,
} from './SeasonPassStatus';
import type { SeasonScopeType } from './SeasonScopeType';
import {
    SeasonScopeTypeFromJSON,
    SeasonScopeTypeFromJSONTyped,
    SeasonScopeTypeToJSON,
    SeasonScopeTypeToJSONTyped,
} from './SeasonScopeType';
import type { SeasonTier } from './SeasonTier';
import {
    SeasonTierFromJSON,
    SeasonTierFromJSONTyped,
    SeasonTierToJSON,
    SeasonTierToJSONTyped,
} from './SeasonTier';
import type { SeasonProgressionRule } from './SeasonProgressionRule';
import {
    SeasonProgressionRuleFromJSON,
    SeasonProgressionRuleFromJSONTyped,
    SeasonProgressionRuleToJSON,
    SeasonProgressionRuleToJSONTyped,
} from './SeasonProgressionRule';

/**
 * 
 * @export
 * @interface UpdateSeasonPassBody
 */
export interface UpdateSeasonPassBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonPassBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonPassBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonPassBody
     */
    imageAssetId?: string;
    /**
     * 
     * @type {SeasonScopeType}
     * @memberof UpdateSeasonPassBody
     */
    scopeType?: SeasonScopeType;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonPassBody
     */
    scopeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonPassBody
     */
    sponsorBrandId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSeasonPassBody
     */
    startDate?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSeasonPassBody
     */
    endDate?: number;
    /**
     * 
     * @type {SeasonPassStatus}
     * @memberof UpdateSeasonPassBody
     */
    status?: SeasonPassStatus;
    /**
     * 
     * @type {Array<SeasonProgressionRule>}
     * @memberof UpdateSeasonPassBody
     */
    progressionRules?: Array<SeasonProgressionRule>;
    /**
     * 
     * @type {Array<SeasonTier>}
     * @memberof UpdateSeasonPassBody
     */
    tiers?: Array<SeasonTier>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonPassBody
     */
    leaderboardCompetitionId?: string;
}



/**
 * Check if a given object implements the UpdateSeasonPassBody interface.
 */
export function instanceOfUpdateSeasonPassBody(value: object): value is UpdateSeasonPassBody {
    return true;
}

export function UpdateSeasonPassBodyFromJSON(json: any): UpdateSeasonPassBody {
    return UpdateSeasonPassBodyFromJSONTyped(json, false);
}

export function UpdateSeasonPassBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSeasonPassBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageAssetId': json['imageAssetId'] == null ? undefined : json['imageAssetId'],
        'scopeType': json['scopeType'] == null ? undefined : SeasonScopeTypeFromJSON(json['scopeType']),
        'scopeId': json['scopeId'] == null ? undefined : json['scopeId'],
        'sponsorBrandId': json['sponsorBrandId'] == null ? undefined : json['sponsorBrandId'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'status': json['status'] == null ? undefined : SeasonPassStatusFromJSON(json['status']),
        'progressionRules': json['progressionRules'] == null ? undefined : ((json['progressionRules'] as Array<any>).map(SeasonProgressionRuleFromJSON)),
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(SeasonTierFromJSON)),
        'leaderboardCompetitionId': json['leaderboardCompetitionId'] == null ? undefined : json['leaderboardCompetitionId'],
    };
}

export function UpdateSeasonPassBodyToJSON(json: any): UpdateSeasonPassBody {
    return UpdateSeasonPassBodyToJSONTyped(json, false);
}

export function UpdateSeasonPassBodyToJSONTyped(value?: UpdateSeasonPassBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageAssetId': value['imageAssetId'],
        'scopeType': SeasonScopeTypeToJSON(value['scopeType']),
        'scopeId': value['scopeId'],
        'sponsorBrandId': value['sponsorBrandId'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'status': SeasonPassStatusToJSON(value['status']),
        'progressionRules': value['progressionRules'] == null ? undefined : ((value['progressionRules'] as Array<any>).map(SeasonProgressionRuleToJSON)),
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(SeasonTierToJSON)),
        'leaderboardCompetitionId': value['leaderboardCompetitionId'],
    };
}

